import QRious from 'qrious';

import { TPeerMap } from '@src/types';

import { LocalStorage, RoomClient } from '@src/services';
import { playSound } from './sounds.helpers';
import { generateRandomUUID, getElementById } from '@src/utils';

// ####################################################
// RESPONSIVE PARTICIPANTS VIEW
// ####################################################

let customRatio = true;
const isHideALLVideosActive = false;

// aspect       0      1      2      3       4
const ratios: any = ['0:0', '4:3', '16:9', '1:1', '1:2'];
let aspect = 1;

// ####################################################
// GET ROOM ID
// ####################################################

export const makeId = (length: number) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
// Persist lastRoom only when you have a real room id (query or join path).
export const getRoomId = () => {
  const qs = new URLSearchParams(window.location.search);
  const queryRoomId = filterXSS(qs.get('room') || '');
  const path = window.location.pathname || '';
  const segments = path.split('/').filter(Boolean); // ['join', '<id>']

  // If path starts with join, then the room id is the second segment
  // Otherwise fall back to the stored lastRoom from localStorage, not substring(6).

  let roomId =
    queryRoomId || (segments[0] === 'join' && segments[1] ? segments[1] : localStorage.getItem('lastRoom') || '');

  if (!roomId) roomId = makeId(12);

  if (queryRoomId || segments[0] === 'join') {
    localStorage.setItem('lastRoom', roomId);
  }

  return roomId;
};

export const getRoomTitle = () => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.toString());
  const roomTitle = filterXSS(params.get('roomTitle') || '');

  return roomTitle;
};

export const getRoomURL = () => `${window.location.origin}/join?room=${getRoomId()}`;

export const getNotify = () => {
  const lS = new LocalStorage();

  const localStorageSettings = lS.getLocalStorageSettings() || lS.SFU_SETTINGS;

  const qs = new URLSearchParams(window.location.search);
  let notify = filterXSS(qs.get('notify') || '');
  if (notify) {
    notify = notify.toLowerCase();
    const queryNotify = notify === '1' || notify === 'true';
    if (queryNotify !== null) {
      return queryNotify;
    }
  }
  notify = localStorageSettings.share_on_join;
  return notify;
};

export const getAspectRatio = () => {
  customRatio = aspect === 0 ? true : false;
  const ratio = ratios[aspect].split(':');
  return ratio[1] / ratio[0];
};

export const getHideMeActive = () => {
  const qs = new URLSearchParams(window.location.search);
  let hide = filterXSS(qs.get('hide') || '');
  let queryHideMe = false;
  if (hide) {
    hide = hide.toLowerCase();
    queryHideMe = hide === '1' || hide === 'true';
  }
  return queryHideMe;
};

let ratio = getAspectRatio();

export const getRandomNumber = (length: number) => {
  let result = '';
  const characters = '0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

// ####################################################################
// TYPING EFFECT
// ####################################################################

export const typeWriter = (text: string = '', setText: (id: string) => void) => {
  let i = 0;
  const speed = 100;
  const timer = setInterval(() => {
    if (i < text.length) {
      setText(text.substring(0, ++i));
    } else {
      clearInterval(timer);
    }
  }, speed);
};

export const generateRandomRoomId = (setRoomId: (id: string) => void) => {
  const text = generateRandomUUID();
  setRoomId('');
  typeWriter(text, setRoomId);
};

export const getDataTimeString = () => {
  const d = new Date();
  const date = d.toISOString().split('T')[0];
  const time = d.toTimeString().split(' ')[0];
  return `${date}-${time}`;
};

export const resetZoom = () => {
  const videoElements = document.querySelectorAll('video');
  videoElements.forEach((video) => {
    video.style.transform = '';
    video.style.transformOrigin = 'center';
  });
};

export const Area = (increment: number, count: number, width: number, height: number, margin = 10) => {
  ratio = customRatio ? 0.75 : ratio;
  let i = 0;
  let w = 0;
  let h = increment * ratio + margin * 2;
  while (i < count) {
    if (w + increment > width) {
      w = 0;
      h = h + increment * ratio + margin * 2;
    }
    w = w + increment + margin * 2;
    i++;
  }
  if (h > height) return false;
  else return increment;
};
export const setWidth = (
  cameras: HTMLCollectionOf<HTMLElement>,
  width: number,
  bigWidth: number,
  margin: number,
  maxHeight: number,
  isOneVideoElement: boolean
) => {
  ratio = customRatio ? 0.68 : ratio;
  for (let s = 0; s < cameras.length; s++) {
    cameras[s].style.width = width + 'px';
    cameras[s].style.margin = margin + 'px';
    cameras[s].style.height = width * ratio + 'px';
    if (isOneVideoElement) {
      cameras[s].style.width = bigWidth + 'px';
      cameras[s].style.height = bigWidth * ratio + 'px';
      const camHeigh = cameras[s].style.height.substring(0, cameras[s].style.height.length - 2);
      if (+camHeigh >= maxHeight) cameras[s].style.height = maxHeight - 2 + 'px';
    }
  }
};

export const saveObjToJsonFile = (dataObj: any, name: string) => {
  const dataTime = getDataTimeString();
  const a = document.createElement('a');
  a.href = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(dataObj, null, 1));
  a.download = `${dataTime}-${name}.txt`;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
  }, 100);
  playSound('download');
};

// ####################################################
// HANDLE ASPECT RATIO
// ####################################################

export const adaptAspectRatio = (participantsCount: number, isHideMeActive: boolean) => {
  /* 
        ['0:0', '4:3', '16:9', '1:1', '1:2'];
    */
  let desktop,
    mobile = 1;
  // desktop aspect ratio
  switch (participantsCount) {
    case 1:
    case 3:
    case 4:
    case 7:
    case 9:
      desktop = 2; // (16:9)
      break;
    case 5:
    case 6:
    case 10:
    case 11:
      desktop = 1; // (4:3)
      break;
    case 2:
    case 8:
      desktop = 3; // (1:1)
      break;
    default:
      desktop = 0; // (0:0)
  }
  // mobile aspect ratio
  switch (participantsCount) {
    case 3:
    case 9:
    case 10:
      mobile = 2; // (16:9)
      break;
    case 2:
    case 7:
    case 8:
    case 11:
      mobile = 1; // (4:3)
      break;
    case 1:
    case 4:
    case 5:
    case 6:
      mobile = 3; // (1:1)
      break;
    default:
      mobile = 3; // (1:1)
  }
  if (participantsCount > 11) {
    desktop = 1; // (4:3)
    mobile = 3; // (1:1)
  }
};

// ####################################################
// HANDLE PARTICIPANTS
// ####################################################

export const getRoomPeers = async (roomClient: RoomClient) => {
  const room_info = await roomClient.getRoomInfo();
  return new Map(JSON.parse(room_info.peers)) as TPeerMap;
};

export const getRemotePeerInfo = async (roomClient: RoomClient, peer_id: string) => {
  const peers = await getRoomPeers(roomClient);
  for (const peer of Array.from(peers.keys()).filter((id) => id === peer_id)) {
    return peers.get(peer)?.peer_info;
  }
  return false;
};

export const saveRoomPeers = async (roomClient: RoomClient) => {
  const peers = await getRoomPeers(roomClient);
  const peersToSave = [];
  for (const peer of Array.from(peers.keys())) {
    peersToSave.push(peers.get(peer)?.peer_info);
  }
  saveObjToJsonFile(peersToSave, 'PARTICIPANTS');
};

export const refreshParticipantsCount = (count: number, adapt = true, isHideMeActive: boolean) => {
  if (adapt) adaptAspectRatio(count, isHideMeActive);
};

export const copyRoomURL = () => {
  const tmpInput = document.createElement('input');
  document.body.appendChild(tmpInput);
  tmpInput.value = getRoomURL();
  tmpInput.select();
  tmpInput.setSelectionRange(0, 99999); // For mobile devices
  navigator.clipboard.writeText(tmpInput.value);
  document.body.removeChild(tmpInput);
};

// ####################################################
// SHARE ROOM
// ####################################################

export const makeRoomQR = () => {
  const qr = new QRious({
    element: getElementById('qrRoom'),
    value: getRoomURL(),
  });
  qr.set({
    size: 256,
  });
};

export const shareRoom = async (roomClient: RoomClient, useNavigator = false) => {
  if (navigator.share && useNavigator) {
    try {
      await navigator.share({ url: getRoomURL() });
    } catch (err) {
      console.error(err);
    }
  }
};

// https://animate.style

export const animateCSS = (element: HTMLElement, animation: string, prefix = 'animate__') => {
  return new Promise((resolve) => {
    const animationName = `${prefix}${animation}`;
    element.classList.add(`${prefix}animated`, animationName);
    const handleAnimationEnd = (event: Event) => {
      event.stopPropagation();
      element.classList.remove(`${prefix}animated`, animationName);
      resolve('Animation ended');
    };
    element.addEventListener('animationend', handleAnimationEnd, { once: true });
  });
};

export { isHideALLVideosActive };
